module.exports = __webpack_public_path__ + "img/2.2e4d2ad9.png";